import { graphql } from "react-relay";

export const QUERY = graphql`
	query videoSourceDropdown_Query {
		Admin {
			VimeoVideoSource {
				VimeoVideoSources {
					edges {
						node {
							id
							name
							isDefault
						}
					}
				}
			}
		}
	}
`;
